import React from 'react';
import { PlayCircle } from 'lucide-react';
import { scrollToId } from '../MarketingHeader';

export const FinalCta = ({ onAuth }) => (
  <section className="mk-section" id="get-started" aria-labelledby="final-title">
    <div className="mk-container">
      <div className="mk-final">
        <h2 id="final-title">Research with the numbers in plain view</h2>
        <p>Every outlook shows its score, drivers, levels and risks. Start a free trial and judge them yourself.</p>
        <div className="mk-hero-ctas mk-center">
          <button type="button" className="mk-btn mk-btn-primary mk-btn-lg" onClick={() => onAuth('signup')} data-testid="final-trial-cta">Start Free Trial</button>
          <a className="mk-btn mk-btn-ghost mk-btn-lg" href="#workspace" onClick={(e) => { if (scrollToId('workspace')) e.preventDefault(); }} data-testid="final-demo-cta">
            <PlayCircle size={18} aria-hidden="true" /> View Product Demo
          </a>
        </div>
        <p className="mk-fine">For research and educational purposes only. Not investment advice.</p>
      </div>
    </div>
  </section>
);
